module.exports = __webpack_public_path__ + "img/syringe.1d14fc4b.svg";